import { FormEventHandler, ReactNode } from 'react';

import clsx from 'clsx';

type FormProps = {
  children: ReactNode;
  isVertical?: boolean;
  onSubmit?: FormEventHandler<HTMLFormElement> | undefined;
};

export default function Form({ children, isVertical, onSubmit }: FormProps) {
  return (
    <form
      className={clsx(
        'grid grid-cols-1 gap-2',
        !isVertical && 'md:grid-cols-2'
      )}
      onSubmit={onSubmit}
    >
      {children}
    </form>
  );
}
